import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as vendorActions } from './store/slice';
import { selectVendorSearchTerm } from './store/selectors';

const { setSearchTerm } = vendorActions;

const VendorSearch = () => {
  const dispatch = useDispatch();
  const searchTerm = useSelector(selectVendorSearchTerm);

  const handleSearch = e => {
    dispatch(setSearchTerm(e.target.value));
  };

  return (
    <div className="table-search-group">
      <div className="form-group mb-0 me-2">
        <input
          type="text"
          className="form-control"
          placeholder="Search by vendor name, location, contact person..."
          value={searchTerm}
          onChange={handleSearch}
        />
      </div>
    </div>
  );
};

export default VendorSearch; 